import { render, staticRenderFns } from "./ConfigurationRow.vue?vue&type=template&id=791fd9fb&scoped=true"
import script from "./ConfigurationRow.vue?vue&type=script&lang=js"
export * from "./ConfigurationRow.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationRow.vue?vue&type=style&index=0&id=791fd9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791fd9fb",
  null
  
)

export default component.exports